import React, { useContext, useRef, useState } from 'react';
import LazyTable from 'app/component/lazy-table';
import { downloadDispatchNote, generateDispatchNote } from 'app/api/dispatchNoteApi';
import { ToastContext } from 'app/context/ToastContext';

type LazyTableHandle = {
  reloadData: () => any;
};

const DispatchNoteTable: React.FC = () => {
  const { showSuccess, showError } = useContext(ToastContext);
  const [loading, setLoading] = useState(false);
  const tableRef = useRef<LazyTableHandle>(null);

  const onDownload = (data: any) => {
    downloadDispatchNote(data.id).then(r => console.log('downloaded'));
  };

  const onGenerate = (data: any) => {
    setLoading(true);

    generateDispatchNote(data.id)
      .then(r => {
        tableRef.current?.reloadData();
      })
      .catch(e => {
        console.log('error', e);
        showError('Chyba', e.detail);
      })
      .finally(() => setLoading(false));
  };

  return LazyTable({
    ref: tableRef,
    initialSortField: 'number',
    createUrl: '/create-dispatch-note',
    editActionAllowed: true,
    labelForCreateEntity: 'Vytvoriť novú sprievodku',
    serverUrl: '/api/dispatch-notes',
    globalFilterFields: ['number', 'documentName'],
    externalLoading: loading,
    columns: [
      { field: 'number', header: 'Číslo sprievodky', sortable: true },
      { field: 'documentName', header: 'Meno dokumentu', sortable: true },
    ],
    additionalActions: [
      {
        icon: 'pi pi-cog',
        tooltip: 'Generovať sprievodku',
        onClick: onGenerate,
        hidden: data => data.generated,
      },
      {
        icon: 'pi pi-download',
        tooltip: 'Stiahnuť sprievodku',
        onClick: onDownload,
        hidden: data => !data.generated,
      },
    ],
  });
};

export default DispatchNoteTable;
